import { render, staticRenderFns } from "./VisionForm.vue?vue&type=template&id=3af21b9c&"
import script from "./VisionForm.vue?vue&type=script&lang=js&"
export * from "./VisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports